import { useQuery } from "react-query";
import { useAuth } from "features/auth";
import { api, ApiError } from "utils/api";
import { reviewKeys } from "./queryKeys";
import type { ArtistReview, UsersReviewRequest } from "../types";

const getUsersReview = async ({
  artistId,
  userId,
}: UsersReviewRequest): Promise<ArtistReview | null> => {
  if (!artistId) {
    return Promise.reject(new Error("Invalid artist"));
  }
  if (!userId) {
    return Promise.reject(new Error("Invalid user id"));
  }

  try {
    return await api.get<ArtistReview>(
      `/artists/${artistId}/reviews/${userId}`,
    );
  } catch (error) {
    // If the API response returns a 404 error, the user simply hasn't reviewed this artist yet
    if (error instanceof ApiError && error.status === 404) {
      return Promise.resolve(null);
    }
    return Promise.reject(error);
  }
};

const useUsersReview = (params: UsersReviewRequest) => {
  const { user: currentUser } = useAuth();
  const userId = params.userId ?? currentUser?.id;

  return useQuery(
    reviewKeys.detail({ ...params, userId }),
    () => getUsersReview({ ...params, userId }),
    {
      enabled: !!userId && !!params.artistId,
    },
  );
};

export { useUsersReview };
